import Model from './Model'
import RGBA from '../Fonts/RGBA'
import FontDefinition from '../Fonts/FontDefinition'
import Arrow from '../Rendering/Arrow'
import UrlExecutor from '../Api/UrlExecutor'

let arrowSize = 6;
let arrowRenderer = new Arrow(2);

export default class HoverNameList extends Model
{

  constructor(width, height, data) {

    super(width, height, data);

    this.people = [];


    this.scroll = 0;

    this.center.x = this.width / 2;
    this.size = 0;
    this.hoveredIndex = 5;

  }

  setPeople(people) {


    // this.people = people.sort((a, b) => {
    //   if (a.getFirstName() === b.getFirstName()) {
    //     return 0;
    //   }
    //   if (a.getFirstName() > b.getFirstName()) {
    //     return 1;
    //   }
    //   return -1;
    // });

    this.people = people.slice(0);
    this.size = this.people.length * 19 + 15 + 15;

    // check if scroll is still within margins
    this.addScroll(0);
    this.needsRendering = true;

  }

  hide() {
    super.hide();
    this.x = -1000;
    this.scroll = 0;
  }

  scheduleHide() {
    this.cancelHide();
    this.timer = setTimeout(() => {
      this.hide();
    }, 200);
  }

  cancelHide() {
    if (this.timer) {
      clearTimeout(this.timer);
    }
  }

  clear(ctx, gameX, gameY, gameWidth, gameHeight) {

    super.clear(...arguments);
    this.previousX = -1000;

  }

  addScroll(n) {

    let size = this.size;


    if (size < this.height) {
      return false;
    }

    if (n !== 0) {
      this.scroll += n;
    }

    if (this.scroll < 0) {
      this.scroll = 0;
    }

    if (this.scroll > size - this.height) {
      this.scroll = size - this.height;
    }

    this.needsRendering = true;

  }

  draw(ctx) {

    let fontSize = 12;
    let lineHeight = 19;
    let padding = 15;

    this.drawBackground(ctx);

    ctx.font = new FontDefinition('Roboto').size(this.scale(fontSize));
    ctx.fillStyle = new RGBA(0);

    let y = 0;

    let box = {
      x : padding,
      y : arrowSize + 2,
      width : this.width - padding * 2,
      height: this.height - arrowSize - 4
    };

    // padding is included in our scrolling part
    y += padding;

    // correct scroll
    y -= this.scroll;

    ctx.save();
    ctx.beginPath();
    ctx.rect(this.scale(box.x), this.scale(box.y), this.scale(box.width), this.scale(box.height));
    ctx.clip();

    ctx.fillStyle = 'black';

    this.people.forEach((person, index) => {

      if (y > -lineHeight && y < this.height) {
        let name = person.getName();

        let suffix = '';
        let size = ctx.measureText(name + suffix);

        while (size.width > this.scale(box.width)) {
          suffix = '...';
          name = name.substring(0, name.length - 1);
          size = ctx.measureText(name + suffix);
        }

        ctx.fillText(name + suffix, this.scale(box.x), this.scale(y + fontSize));
      }

      y += lineHeight;

    });

    ctx.restore();

    if (this.scroll < this.size - this.height) {
      this.drawArrow(ctx);
    }

  }

  drawArrow(ctx) {

    let margin = 10;

    let box = {
      width: 15,
      height: 15,
    };

    box.x = this.width - box.width - margin;
    box.y = this.height - box.height - margin;



    ctx.beginPath();
    // ctx.rect(this.scale(box.x), this.scale(box.y), this.scale(box.width), this.scale(box.height));

    ctx.moveTo(this.scale(box.x + box.width / 2), this.scale(box.y));
    ctx.lineTo(this.scale(box.x + box.width / 2), this.scale(box.y + box.height));

    let size = 6;

    ctx.moveTo(this.scale(box.x + box.width / 2 - size), this.scale(box.y + box.height - size));
    ctx.lineTo(this.scale(box.x + box.width / 2), this.scale(box.y + box.height));
    ctx.lineTo(this.scale(box.x + box.width / 2 + size), this.scale(box.y + box.height - size));

    ctx.strokeStyle = new RGBA(0).alpha(.2);
    ctx.lineWidth = this.scale(2);
    ctx.stroke();

  }

  drawBackground(ctx) {

    let radius = 10;

    ctx.beginPath();
    //ctx.rect(0,0, this.scale(this.width), this.scale(this.height));

    ctx.moveTo(this.scale(radius), this.scale(arrowSize));

    // top
    ctx.lineTo(this.scale((this.width / 2)  - arrowSize), this.scale(arrowSize));
    ctx.lineTo(this.scale(this.width / 2), 0);
    ctx.lineTo(this.scale((this.width / 2)  + arrowSize), this.scale(arrowSize));
    ctx.lineTo(this.scale(this.width - radius), this.scale(arrowSize));

    // topright
    ctx.quadraticCurveTo(this.scale(this.width), this.scale(arrowSize), this.scale(this.width), this.scale(radius + arrowSize));

    // right
    ctx.lineTo(this.scale(this.width), this.scale(this.height - radius));

    // bottomright
    ctx.quadraticCurveTo(this.scale(this.width), this.scale(this.height), this.scale(this.width - radius), this.scale(this.height));

    // bottom
    ctx.lineTo(this.scale(radius), this.scale(this.height));

    // bottomleft
    ctx.quadraticCurveTo(0, this.scale(this.height), 0, this.scale(this.height - radius));

    // left
    ctx.lineTo(0, this.scale(radius + arrowSize));

    // topleft
    ctx.quadraticCurveTo(0, this.scale(arrowSize), this.scale(radius), this.scale(arrowSize));

    ctx.fillStyle = new RGBA(255);
    ctx.fill();


  }

  getHoverIndex(x,y) {
    let hoveredIndex = Math.floor(((y + this.scroll - arrowSize) / 19)) - 2;

    if (hoveredIndex < 0) {
      hoveredIndex = null;
    }

    return hoveredIndex;
  }

  hover(x,y)
  {

    let hoveredIndex = this.getHoverIndex(x, y);

    if (this.hoveredIndex !== hoveredIndex) {
      this.hoveredIndex = hoveredIndex;
      this.needsRendering = true;
    }

    this.cancelHide();

  }
  click(x,y)
  {

    let hoveredIndex = this.getHoverIndex(x, y);
    let person = this.people[hoveredIndex];

    if (person) {
      UrlExecutor.execute(person.data.url);
    }

  }

}
